import React, {useEffect} from 'react';
import {connect, useSelector} from "react-redux";


// components
import {showLoader} from "../../../components/loader/loader";

// actions
import {
    ADD_STATE,
    REMOVE_STATE,
} from "../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../redux/selectors";
import TranslateStatisticsList from "./TrsanslateStatisticsList";

import '../../../assets/css/TranslateMetrics.css'


const TranslateStatistics = props => {
    const path = props.path || 'translate/statistics';
    const componentState = useSelector(state => getStateByPath(state, path));
    const { loading } = componentState?.data || false;



    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);



    return <>
        {loading && showLoader()}

        { componentState && <TranslateStatisticsList path={path}/> }
    </>
}

const mapStateToProps = _ => ({});

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE
});

export default connect(mapStateToProps, mapActionsToProps)(TranslateStatistics)